import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useRestaurantModel } from "../restaurantModel";
export const DataBox = () => {
    const { setIVisibleDrawer } = useRestaurantModel();

    const onAdd = () => {
        setIVisibleDrawer("add")
    }

    const title = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onAdd}
        >新增</Button>
    </>
    return (
        <YhBox title={title}>
            <DataTable />
        </YhBox>
    )
}